import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { switchMap, take } from 'rxjs';
import { RiseNgInput } from '@riseplus-cdk/rise-ng-input';
import { ErrorHelper } from '@riseplus-cdk/rise-ng-utils';
import { AuthPayload } from '@services/auth/auth.model';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, RiseNgInput],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  fb = inject(FormBuilder);

  form = this.fb.group({
    username: [null, Validators.required],
    password: [null, Validators.required],
  });
  errors: Partial<AuthPayload> = {};
  isLoading = signal(false);
  errorMessage = signal<string>('');

  private router = inject(Router);
  private authService = inject(AuthService);

  login() {
    this.errors = {};
    if (this.form.invalid) {
      this.errors = ErrorHelper.setErrorWithDetails(this.form).processedErrors;
      return;
    }

    this.isLoading.set(true);

    this.authService
      .login(this.form.value as unknown as AuthPayload)
      .pipe(
        take(1),
        // switchMap(() => this.authService.profile()),
        switchMap(async () => this.authService.getUser()),
      )
      .subscribe({
        next: (user) => {
          this.isLoading.set(false);
          void this.router.navigate(['/']);
        },
        error: (err) => {
          this.isLoading.set(false);

          if (!this.form.value.username) return;

          if (err.status === 401 && err.error?.is_set_password === false) {
            localStorage.setItem('username', this.form.value.username);
            localStorage.setItem('firstTime', 'true');
            void this.router.navigate(['/set-password']);
            return;
          }

          this.errorMessage.set('Username or password incorrect.');
        },
      });
  }
}
